import React from "react";

const MemberCard = ({ cardData }) => {
  return (
    <div className="member-card-wrap">
      <div className="member-card">
        {/* Decorative circles */}
        <div className="mc-circle mc-circle-1"></div>
        <div className="mc-circle mc-circle-2"></div>

        {/* Top row — Logo + MEMBER label */}
        <div className="mc-top">
          <div className="mc-logo-top">
            <img
              src="./images/logo.png"
              alt="Aaroh Foods"
              className="mc-brand-logo"
            />
          </div>
          <div className="mc-tag">MEMBER</div>
        </div>

        {/* Card number */}
        <div className="mc-number">
          <span>1234</span>
          <span>5678</span>
          <span>9012</span>
          <span>3456</span>
        </div>

        {/* Bottom row — name + expires + Mastercard rings */}
        <div className="mc-bottom">
          <div className="mc-holder">
            <div className="mc-holder-label">Card Holder</div>
            <div className="mc-holder-name">{cardData?.name || "Member"}</div>
          </div>
          <div className="mc-expires">
            <div className="mc-holder-label">Expires</div>
            <div className="mc-holder-name">06/25</div>
          </div>
          <div className="mc-logo-rings">
            <span className="mc-ring mc-ring-left"></span>
            <span className="mc-ring mc-ring-right"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberCard;
